import React from 'react';

const ShipmentCard = ({shipment}) => {
    if (!shipment) {
        return <p className="text-sm text-bark-500">Нет данных</p>
    }
    return (
        <ul className="space-y-2 rounded-2xl border border-stone-200/80 bg-cream-50/80 p-4 text-sm">
            <li><span className="text-bark-500">Имя: </span>{shipment.name}</li>
            <li><span className="text-bark-500">Адрес: </span>{shipment.address}</li>
            <li><span className="text-bark-500">Телефон: </span>{shipment.phone}</li>
            <li><span className="text-bark-500">Email: </span>{shipment.email}</li>
        </ul>
    );
};

export default ShipmentCard;
